import { jsxs as l, jsx as e } from "react/jsx-runtime";
const t = ({ id: a }) => /* @__PURE__ */ l(
  "div",
  {
    role: "presentation",
    "data-ref": "eCheckbox",
    className: "ag-labeled ag-label-align-right ag-checkbox ag-input-field",
    children: [
      /* @__PURE__ */ e(
        "div",
        {
          "data-ref": "eLabel",
          className: "ag-input-field-label ag-label ag-hidden ag-checkbox-label",
          "aria-hidden": "true",
          role: "presentation",
          id: `ag-${a}-label`
        }
      ),
      /* @__PURE__ */ e(
        "div",
        {
          "data-ref": "eWrapper",
          className: "ag-wrapper ag-input-wrapper ag-checkbox-input-wrapper ag-checked",
          role: "presentation",
          children: /* @__PURE__ */ e(
            "input",
            {
              "data-ref": "eInput",
              className: "ag-input-field-input ag-checkbox-input",
              type: "checkbox",
              id: `ag-${a}-label`,
              "aria-label": "Press SPACE to toggle cell value (checked)"
            }
          )
        }
      )
    ]
  }
);
export {
  t as BooleanCell
};
//# sourceMappingURL=index.es5534.js.map
